import styled from 'styled-components'
import { Container } from '../../atoms'

export const MessageBoxContainer = styled(Container)`
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  :after {
    display: none;
  }

  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    flex-direction: column;
  }

  &.container-content-error {
    .h4 {
      margin-bottom: 20px;
    }

    .btn-alternative {
      border-color: ${ (props) => props.theme.colors.weiss };
      color: ${ (props) => props.theme.colors.weiss };
    }
  }
`

export const Text = styled.div`
  margin-right: 30px;
  display: flex;
  flex-direction: column;

  // required for IE11
  width: 100%;

  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    margin-bottom: 20px;
    margin-right: 0px;
  }
`
